<script setup>
import { useLoading } from '@/loader';
import { useNewsPaperStore, usePublishedStore } from '@/stores';
import { onMounted, onBeforeMount, ref, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic';
import Datepicker from '@vuepic/vue-datepicker';
import enabledConfig from '@/ckeditor5/config/enabled';
import { useNotification } from '@kyvg/vue3-notification';
import DamImageBrowser from '../../components/newspaper/DamImageBrowser.vue';
import DamImages from '../../components/newspaper/DamImages.vue';
import DamFiles from '../../components/newspaper/DamFiles.vue';
import RelatedRemoteNews from '@/components/newspaper/RelatedRemoteNews.vue';
import RelatedRemoteBrowser from '../../components/newspaper/RelatedRemoteBrowser.vue';
import GenericModal from '@/components/generic-modal'
import NewspaperRepublish from '@/components/newspaper-republish/NewspaperRepublish.vue';
import ImageEditor from '@/components/image-editor';
import { useDamImageEditor } from '@/components/image-editor';
import { useRecordLock } from '@/composable/lockrecord';
//import CKEditorInspector from '@ckeditor/ckeditor5-inspector';

const loader = useLoading();
const publishedStore = usePublishedStore();
const newsPaperStore = useNewsPaperStore();
const { remoteDetail } = storeToRefs(publishedStore);
const lock = useRecordLock("remote", remoteDetail);
const route = useRoute();
const router = useRouter();


const { notify } = useNotification();

// Template refs
const relatedBrowser = ref(null);
const damBrowser = ref(null);

// DateTime Picker
const textInputOptions = {
    format: "dd/MM/yyyy HH:mm"
};

let modalRelatedBrowser = null;
let modalDamBrowser = null;




const imgToEdit = ref(null);
const damEditor = ref(null);
const damEditorModal = ref(null);
const showImageEditor = ref(false);

const onDamEdit = (media) => {
    openEditor(media, 'inline');
};

const onDamEditorClosing = () => {
    imgToEdit.value = null;
};

const onSaveImage = (file) => {
    damImageEditor.saveImage(file).then( (value) => {
        closeImageEditor();
    });
    return;
    damImageEditor.saveImage(file)
    /*
    if(damImageEditor.imageEditorData.mode == 'inline') {
        let url = new URL(damImageEditor.imageEditorData.media.getAttribute("src"), window.document.location.origin);
        let params = url.searchParams;
        const fileName = url.pathname.split('\\').pop().split('/').pop();
        const myNewFile = new File([file], decodeURI(fileName), {type: file.type});
        publishedStore.uploadImage(myNewFile, route.params.newspaperid, true).then( (response) => {
            let ckver = Number.parseInt(params.get("ckver"));
            if(isNaN(ckver)) {
                ckver = 1;
            }
            bodytextEditor.value.instance.execute( 'replaceImageSource', { source: response.default + "?ckver=" + (ckver+1) } )
            imageEditorData.media = null;
            imageEditorData.mode = null;
        })
    } else if(imageEditorData.mode == 'attachment') {
        if(imageEditorData.media?.type == 'remote') {
            const fileName = imageEditorData.media.file_name;
            const myNewFile = new File([file], decodeURI(fileName), {type: file.type});
            imageEditorData.media.url = URL.createObjectURL(myNewFile);
            imageEditorData.media.orig = myNewFile;
            delete imageEditorData.media.type;
            delete imageEditorData.media.remote_id;
        } else {
            const fileName = imageEditorData.media.orig.name;
            let myNewFile = new File([file], decodeURI(fileName), {type: file.type});
            imageEditorData.media.url = URL.createObjectURL(myNewFile);
            imageEditorData.media.orig = myNewFile;
        }
    } else {
        console.warn("Save image editor mode not supported:", imageEditorDatas.mode);
    }
    */
    closeImageEditor();
}

let imageEditorData = {
    mode: null,
    media: null,
    index: null
};

const closeImageEditor = () => {
    /*
    imageEditorData.media = null;
    imageEditorData.mode = null;
    imageEditorData.index = null;
    */
    damImageEditor.closeEditor();
    showImageEditor.value = false;
}


const openEditor = (media, mode) => {

    damImageEditor.openEditor(media, mode, imgToEdit);
    showImageEditor.value = true;
    return;

    imageEditorData.mode = mode;

    console.log("Media edit", media);
    if (mode == 'inline') {
        let src = media.getAttribute("src");
        if (src /* && src.startsWith("/published-images/")*/) {
            imgToEdit.value = src;
            imageEditorData.media = media;
        } else {
            console.log("Immagine remota inline non supportata", media);
        }
    } else if (mode == 'attachment') {
        if (media?.type == 'remote') {
            // From remote
            console.warn("Immagine remota allegata non supportata", media);
            imgToEdit.value = media.publicUrl + media.url;
            imageEditorData.media = media;
            imageEditorData.index = publishedStore.draftDetailImages.images.indexOf(media);
        } else if (media.orig) {
            // From PC
            imgToEdit.value = media.url;
            imageEditorData.media = media;
            imageEditorData.index = publishedStore.draftDetailImages.images.indexOf(media);
        } else if (media.path) {
            // From draft
            imgToEdit.value = "/published-images/" + media.path;
            imageEditorData.media = media;
            imageEditorData.index = publishedStore.draftDetailImages.images.indexOf(media);
        }
    } else {
        console.warn("Modalità non supportata", mode);
    }

    showImageEditor.value = true;
}

// Remote news
async function initRemoteDetail(remote_id) {
    loader.show();
    if (!remote_id && route.params.id) {
        remote_id = route.params.id;
    }
    //publishedStore.fetchRemotePublishedDetail(remote_id)
    publishedStore.fetchRemoteDetail(route.params.newspaperid, remote_id)
        .then((data) => {
            editorData.value = publishedStore.remoteDetail.bodytext;
            bodytextEditor.value.instance.draftId = publishedStore.remoteDetail.id;
            if (publishedStore.remoteDetail.starttime != null) {
                enabledDate.value = false;
            }
        }).catch((err) => {
            notify({
                text: "Errore nel caricamento della notizia pubblicata",
                type: "danger"
            });
            console.log("Error loading remote news", err);
        }).finally(() => {
            loader.hide();
        });
}

// Component States
const editorData = ref("");
const editor = ClassicEditor
let bodytextEditorConfig = enabledConfig;
// Disattivo le immagini inline (per ora)

bodytextEditorConfig['dam-image']['click'] = onDamBrowse;
bodytextEditorConfig['dam-edit']['click'] = onDamEdit;
bodytextEditorConfig.ServerId = route.params.newspaperid.split("-")[0];
bodytextEditorConfig.NewspaperId = route.params.newspaperid;
bodytextEditorConfig['newsPaperStore'] = {
    getNewspaperById: newsPaperStore.getNewspaperById
}

initRemoteDetail();

/*
bodytextEditorConfig.newsPaperStore = newsPaperStore;
*/
/*
bodytextEditorConfig['toolbar']['items'] = bodytextEditorConfig['toolbar']['items'].filter((item, index) => {
    return !(item == 'uploadImage')
});
*/
onMounted(async () => {
    /*
    damEditorModal.value = new bootstrap.Modal(damEditor.value);
    damEditorModal.value._config.keyboard = false;
    $(damEditorModal.value._element).on('hide.bs.modal', onDamEditorClosing);
    */

    modalDamBrowser = new bootstrap.Modal(damBrowser.value);
    modalDamBrowser._config.keyboard = false;
    $(modalDamBrowser._element).on('hide.bs.modal', onDamClosing);

    modalRelatedBrowser = new bootstrap.Modal(relatedBrowser.value);
    modalRelatedBrowser._config.keyboard = false;
    $(modalRelatedBrowser._element).on('hide.bs.modal', onRelatedClosing)
    
    
});

onUnmounted(() => {
    publishedStore.remoteDetail = {};
    lock.remove();
});

function closeNews() {
    router.push({ name: "draft-list-newspaper", params: { newspaperid: route.params.newspaperid } });
}

function saveNewsAndClose() {
    saveNews(false).then((res) => {
        publishedStore.resetLocalStore();
        closeNews();
    });
}

function saveNews(refresh = true) {
    if (bodytextEditor.value.instance.plugins.get("SourceEditing").isSourceEditingMode) {
        bodytextEditor.value.instance.plugins.get("SourceEditing").isSourceEditingMode = false;
    }
    publishedStore.remoteDetail.bodytext = editorData;
    return new Promise((resolve, reject) => {
        try {
            loader.show();
            publishedStore.saveRemote(newsPaperStore.selectedNewspaper).then((data) => {
                /*
                published_report.value = data;
                activeTab.value = 'report';
                */
                if (refresh) {
                    initRemoteDetail(route.params.id).then(() => {
                        notify({
                            text: "Notizia pubblicata",
                            type: "success"
                        });
                        resolve();
                    });
                } else {
                    notify({
                        text: "Notizia pubblicata",
                        type: "success"
                    });
                    resolve();
                }

            }).catch((reason) => {
                notify({
                    text: reason.message ?? "Errore nel salvataggio della notizia",
                    type: "error",
                });
                console.log(reason);
            }).finally(() => {
                loader.hide();
            });
        } catch (err) {
            notify({
                text: err.message,
                type: "error"
            });
            reject(e.message);
        }
    });
}

// CKEditor
const bodytextEditor = ref(null);

const damImageEditor = useDamImageEditor(publishedStore, bodytextEditor, route.params.newspaperid)

async function publishInlineImage(file) {
    return new Promise((resolve, reject) => {
        publishedStore.uploadImage(file, route.params.newspaperid).then((data) => {
            resolve(data);
        }).catch((reason) => {
            reject(error);
        });
    });
}

const checkAndParseFB = () => {
    if(window.FB) {
        FB.XFBML.parse();
    } else {
        setTimeout(() => checkAndParseFB, 100);
    }
}

function onBodytextEditorReady(evt) {
    bodytextEditor.value.instance.model.on('_afterChanges', evt => {
        checkAndParseFB();
    });
    //bodytextEditor.value.instance.saveDraft = saveNews;
    //bodytextEditor.value.instance.uploadImage = publishedStore.publishInlineImage;
    bodytextEditor.value.instance.uploadImage = publishInlineImage;
    bodytextEditor.value.instance.NewspaperId = route.params.newspaperid;
    //CKEditorInspector.attach( bodytextEditor.value.instance );
}

// Image management
const showDamBrowser = ref(false);
const damContext = ref("");

function onDamBrowse(show, context = "attach") {
    modalDamBrowser.show();
    showDamBrowser.value = true;
    damContext.value = context;
}

function onDamClosing() {
    showDamBrowser.value = false;
}

function onDamClose() {
    modalDamBrowser.hide();
}

function onAddImage(image) {
    bodytextEditor.value.instance.execute('insertImage', { source: image.publicUrl + "/" + image.url + "?uid=" + image.remote_id });
    let lastRange = bodytextEditor.value.instance.ui.editor.model.document.selection.getLastRange();
    bodytextEditor.value.instance.model.change(writer => {
        writer.setSelection(writer.createPositionAfter(bodytextEditor.value.instance.ui.editor.model.document.selection.getSelectedElement()));
    });
}

const onAddImageAsLink = (image) => {
    bodytextEditor.value.instance.model.change(writer => {
        const linkText = writer.createText(image.file_name);

        writer.setAttribute('linkHref', `${image.publicUrl}${image.url}`, linkText);
        bodytextEditor.value.instance.model.insertContent(linkText, bodytextEditor.value.instance.model.document.selection);
    });
}

// Related
const showRelatedBrowser = ref(false);

function onRelatedBrowse() {
    modalRelatedBrowser.show();
    showRelatedBrowser.value = true;
}

function onRelatedClose() {
    modalRelatedBrowser.hide();
}

function onRelatedClosing() {
    showRelatedBrowser.value = false;
}

function onAddRelated(remote) {
    if (!remoteDetail.value.related.find((item) => {
        return item.uid == remote.uid;
    })) {
        remoteDetail.value.related.push({
            uid: remote.uid,
            datetime: remote.datetime,
            endtime: remote.endtime,
            hidden: remote.hidden,
            sorting: 9999,
            starttime: remote.starttime,
            title: remote.title,
        });
    }
}

const enabledDate = ref(true);

function onStartTimeChange(value) {
    if (value) {
        publishedStore.remoteDetail.datetime = value;
        enabledDate.value = false;
    } else {
        enabledDate.value = true;
        publishedStore.remoteDetail.datetime = null;
    }
}

// Publishing
const showPublish = ref(false);
const showRepublish = ref(false);
const singleRepublish = ref(false);

function republishSingleNews() {
    if (document.getElementsByName("remote-edit")[0].checkValidity()) {
        if (bodytextEditor.value.instance.plugins.get("SourceEditing").isSourceEditingMode) {
            bodytextEditor.value.instance.plugins.get("SourceEditing").isSourceEditingMode = false;
        }
        publishedStore.remoteDetail.bodytext = editorData;
        singleRepublish.value = true;
        showRepublish.value = true;
    } else {
        document.getElementsByName("remote-edit")[0].reportValidity();
    }
}

function republishNews() {
    if (document.getElementsByName("remote-edit")[0].checkValidity()) {
        if (bodytextEditor.value.instance.plugins.get("SourceEditing").isSourceEditingMode) {
            bodytextEditor.value.instance.plugins.get("SourceEditing").isSourceEditingMode = false;
        }
        publishedStore.remoteDetail.bodytext = editorData;
        singleRepublish.value = false;
        showRepublish.value = true;
    } else {
        document.getElementsByName("remote-edit")[0].reportValidity();
    }
}

function onPublishClose(value) {
    showPublish.value = false;
    if (value == 'done') {
        closeNews();
    }
}

function onRepublishAction(value) {
    if (value == 'close') {
        showRepublish.value = false;
    } else if (value == 'done') {
        showRepublish.value = false;
        closeNews();
    }
}

// Preview

const showModalPreview = ref(false);
const previewUrl = ref("");

const choosePreviewNewspaper = () => {
    saveNews(false).then(() => {
        previewUrl.value = publishedStore.getPreviewUrl(newsPaperStore.selectedNewspaper);
        showModalPreview.value = true;
        //draftStore.openPreview();
    });
}

const modalPreviewAction = (action) => {
    if (action == "close") {
        showModalPreview.value = false;
        previewUrl.value = "about:blank";
    }
}

</script>

<template>
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>Modifica pubblicazione su <mark>{{ newsPaperStore.getNewspaperName(route.params.newspaperid)
                            }}</mark></h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                        <li class="breadcrumb-item active">News</li>
                    </ol>
                </div>
            </div>
        </div>
    </section>

    <section class="content">
        <div class="container-fluid">
            <div class="card card-default">
                <form name="remote-edit">
                    <div class="card-body">

                        <div class="form-group">
                            <label for="title">Titolo</label>
                            <input required type="text" class="form-control" id="title" v-model="remoteDetail.title"
                                @keydown.enter="(e) => e.preventDefault()">
                        </div>
                        <div class="form-group">
                            <label for="short">Sottotitolo</label>
                            <!--<input type="text" class="form-control" id="short" v-model="remoteDetail.short" @keydown.enter="(e) => e.preventDefault()">-->
                            <textarea class="form-control" rows="2" id="short" v-model="remoteDetail.short"
                                @keydown.enter="(e) => e.preventDefault()"></textarea>
                        </div>
                        <div class="form-group">
                            <label>Testo</label>
                            <div id="editor-container">
                                <ckeditor ref="bodytextEditor" :disabled="(remoteDetail.type == 0) ? false : true"
                                    :editor="editor" v-model="editorData" :config="bodytextEditorConfig"
                                    @ready="onBodytextEditorReady()"></ckeditor>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="short">Parole chiave <small>(separate da ,)</small></label>
                            <input type="text" :disabled="(remoteDetail.type == 0) ? false : true"
                                class="form-control" id="keywords" v-model="remoteDetail.keywords"
                                @keydown.enter="(e) => e.preventDefault()">
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="title">Data</label>
                                    <datepicker required v-model="remoteDetail.datetime" :disabled="!enabledDate"
                                        id="datetime" locale="it" format="dd/MM/yyyy HH:mm" auto-apply
                                        :close-on-auto-apply="false" partial-flow :flow="['calendar', 'time']"
                                        :text-input="textInputOptions" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="author">Autore</label>
                                    <input type="text" :disabled="(remoteDetail.type == 0) ? false : true"
                                        class="form-control" v-model="remoteDetail.author" id="author"
                                        @keydown.enter="(e) => e.preventDefault()" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="title">Data inizio</label>
                                    <!-- input type="text" class="form-control" id="starttime" v-model="draftDetail.starttime" -->
                                    <datepicker v-model="remoteDetail.starttime" locale="it" format="dd/MM/yyyy HH:mm"
                                        auto-apply :close-on-auto-apply="false" partial-flow
                                        :flow="['calendar', 'time']" :text-input="textInputOptions"
                                        @update:model-value="onStartTimeChange" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="title">Data fine</label>
                                    <!-- input type="text" class="form-control" id="endtime" v-model="draftDetail.endtime" -->
                                    <datepicker v-model="remoteDetail.endtime" locale="it" format="dd/MM/yyyy HH:mm"
                                        auto-apply :close-on-auto-apply="false" partial-flow
                                        :flow="['calendar', 'time']" :text-input="textInputOptions" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-6">
                                <label>Posizione</label>
                                <div class="form-group">
                                    <div v-for="(position, index) in newsPaperStore.positions" :key="position.id">
                                        <div class="icheck-primary d-inline">
                                            <input type="checkbox" :id="position.id" :true-value="[]"
                                                v-model="remoteDetail.positions" :value="position.id">
                                            <label :for="position.id">{{ position.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <label></label>
                                <div class="form-group clearfix">
                                    <div class="icheck-primary d-inline">
                                        <input type="checkbox" id="premium" true-value="1" false-value="0"
                                            v-model="remoteDetail.premium">
                                        <label for="premium">PREMIUM News</label>
                                    </div>
                                </div>

                                <div class="form-group clearfix">
                                    <div class="icheck-primary d-inline">
                                        <input type="checkbox" id="hidden" true-value="1" false-value="0"
                                            v-model="remoteDetail.hidden">
                                        <label for="hidden">Nascondi</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="title">Data inizio boxatura</label>
                                    <datepicker v-model="remoteDetail.tx_ttnewsextra_boxed_start" locale="it"
                                        format="dd/MM/yyyy HH:mm" auto-apply :close-on-auto-apply="false" partial-flow
                                        :flow="['calendar', 'time']" :text-input="textInputOptions" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="title">Data fine boxatura</label>
                                    <datepicker v-model="remoteDetail.tx_ttnewsextra_boxed_end" locale="it"
                                        format="dd/MM/yyyy HH:mm" auto-apply :close-on-auto-apply="false" partial-flow
                                        :flow="['calendar', 'time']" :text-input="textInputOptions" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <label>Immagini</label>
                                <dam-images :store="publishedStore" :media_file_path="'/published-images'"
                                    @ondambrowse="onDamBrowse(true, 'attach')"
                                    @ondamedit="(media) => openEditor(media, 'attachment')" />

                            </div>
                            <div class="col-md-6">
                                <label>Allegati</label>
                                <dam-files :store="publishedStore" :media_file_path="'/published'"
                                    @ondambrowse="onDamBrowse(true, 'file')" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 ">
                                <label>Notizie correlate</label>
                                <RelatedRemoteNews @onrelatedbrowse="onRelatedBrowse(true)"
                                    v-model="remoteDetail.related" />
                            </div>
                        </div>

                    </div>

                    <div class="card-footer">
                        <div class="bg-light rounded elevation-1 p-2" style="position:fixed; bottom:10px; right:10px;">
                            <div class="btn btn-sm btn-secondary" @click="choosePreviewNewspaper()" title="Anteprima"><i
                                    class="fa-regular fa-eye"></i></div>
                            <div class="btn btn-sm btn-secondary ml-1" @click="closeNews()" title="Chiudi"><i
                                    class="fa-solid fa-xmark"></i></div>

                            <div class="btn btn-sm btn-secondary ml-1" @click="saveNews()" title="Salva"><i
                                    class="fa-solid fa-floppy-disk"></i></div>
                            <div class="btn btn-sm btn-secondary ml-1" @click="saveNewsAndClose()"
                                title="Salva e chiudi"><i class="fa-solid fa-floppy-disk"></i> <i
                                    class="fa-solid fa-xmark fa-xs"></i></div>

                            <!--
                  <div class="btn-group">
                    <div class="btn btn-sm btn-secondary ml-1" @click="saveNews()">Salva</div>
                    <button type="button" class="btn btn-sm btn-secondary dropdown-toggle dropdown-icon" data-toggle="dropdown" aria-expanded="false">
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu" role="menu">
                      <div class="btn btn-sm" @click="saveNewsAndClose()">Salva e chiudi</div>
                    </div>
                  </div>
                  -->

                            <div class="btn-group">
                                <div class="btn btn-sm btn-primary ml-1" @click="republishSingleNews()">Pubblica</div>
                                <button v-if="remoteDetail.type == 0" type="button"
                                    class="btn btn-sm btn-primary dropdown-toggle dropdown-icon" data-toggle="dropdown"
                                    aria-expanded="false">
                                    <span class="sr-only">Toggle Dropdown</span>
                                </button>
                                <div v-if="remoteDetail.type == 0" class="dropdown-menu dropdown-menu-right"
                                    role="menu">
                                    <div class="btn btn-sm" @click="republishNews()">Pubblica tutte</div>
                                </div>
                            </div>
                            <!-- div class="btn btn-sm btn-primary ml-1" @click="publishNews()">Pubblica</div -->
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </section>

    <ImageEditor :media="imageEditorData.media" :imgToEdit="imgToEdit" :show="showImageEditor" @saveImage="onSaveImage"
        @closeImageEditor="closeImageEditor" />

    <div class="modal fade" ref="damBrowser" tabindex="-1" role="dialog" data-keyboard="false">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Media</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>

                <div class="modal-body">
                    <DamImageBrowser ref="modal_browser" :show="showDamBrowser" :store="publishedStore"
                        @addimage="onAddImage" @addimageaslink="onAddImageAsLink" @hidebsmodal="onDamClose"
                        :context="damContext" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" ref="relatedBrowser" tabindex="-1" role="dialog" data-keyboard="false">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Notizie correlate</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>

                <div class="modal-body">
                    <RelatedRemoteBrowser ref="modal_related_browser" :show="showRelatedBrowser"
                        :language="remoteDetail.language_id" :remote_id="remoteDetail.uid" @hidebsmodal="onRelatedClose"
                        @addrelated="onAddRelated" />
                </div>
            </div>
        </div>
    </div>

    <!-- BEGIN: Modal Publish -->
    <!-- PublishPublished id="modal_publish" ref="modal_publish" :show="showPublish" v-if="newsPaperStore.selectedNewspaper" @modalAction="(value) => onPublishClose(value)" / -->
    <NewspaperRepublish :show="showRepublish" :single="singleRepublish" :remote_id="remoteDetail.uid"
        :newspaper_code="route.params.newspaperid" @modalAction="(value) => onRepublishAction(value)" />

    <!-- BEGIN: Modal Publish -->
    <GenericModal size="modal-xxl" body-class="p-0" :show="showModalPreview" @modal-action="modalPreviewAction">
        <template #default>
            <iframe class="published-preview" style="display:block; border:0;" :src="previewUrl"></iframe>
        </template>
    </GenericModal>
</template>
<style scoped>
.published-preview {
    height: 80vh;
    width: 100%;
}
</style>
